export const BLOG_POSTS = [
  {
    slug: "ejercicio-aerobico-esports-puerto-rico",
    title: "Ejercicio aeróbico en esports: la ventaja científica para reaccionar más rápido en PREL",
    excerpt: "Un estudio en e-athletes mostró mejoras en aim, memoria visual y tiempo de reacción tras 30 minutos de cardio moderado.",
    cover: "/WEBLONG3_optimized.jpg",
    category: "Rendimiento Competitivo",
    author: "PR Esports League",
    date: "2026-02-22",
    content: [
      "En esports, cada milisegundo cuenta. En la Puerto Rico Esports League lo vemos en cada torneo: reaccionar mejor y sostener enfoque marca diferencias reales.",
      "Un estudio publicado en 2023 (Medicine) evaluó e-athletes con 30 minutos de ejercicio aeróbico moderado (64–76% de FC máxima) y encontró mejoras significativas en precisión/velocidad de apuntado, memoria visual y tiempo de reacción.",
      "La aplicación práctica para competencia es simple: integra 30 minutos de cardio moderado antes de warm-up técnico y prueba tus métricas (aim/reacción) para medir tu progreso.",
      "Gaming + fitness no es moda; es ventaja competitiva. Si compites en eventos PREL, este protocolo puede ayudarte a llegar más preparado al primer match.",
      "Fuente: Zhang W, et al. Effects of acute moderate-intensity aerobic exercise on cognitive function in E-athletes. Medicine (2023).",
    ],
  },
  {
    slug: "calendario-esports-puerto-rico-2026",
    title: "Calendario competitivo de esports en Puerto Rico 2026",
    excerpt: "Fechas clave, tipos de torneos y cómo prepararte para competir durante todo el año.",
    cover: "/friday.png",
    category: "Noticias",
    author: "PR Esports League",
    date: "2026-02-21",
    content: [
      "El 2026 viene cargado de eventos competitivos en Puerto Rico, desde torneos escolares hasta activaciones de alto impacto.",
      "Nuestro objetivo es facilitar el acceso a la competencia con formatos solo, dúo y team para distintas comunidades.",
      "Mantente pendiente al registro oficial para asegurar tu espacio en cada evento.",
    ],
  },
  {
    slug: "guia-primer-torneo-presencial",
    title: "Cómo prepararte para tu primer torneo presencial",
    excerpt: "Checklist práctica para llegar listo: setup, mentalidad competitiva y logística de evento.",
    cover: "/usbat.png",
    category: "Guías de Competencia",
    author: "PR Esports League",
    date: "2026-02-20",
    content: [
      "Prepararte para un torneo presencial requiere más que jugar bien: necesitas plan, descanso y ejecución.",
      "Recomendamos confirmar tu registro, revisar reglas, llevar periféricos en buen estado y llegar temprano al check-in.",
      "La consistencia fuera del juego también define resultados dentro de la arena.",
    ],
  },
  {
    slug: "school-wars-impacto-talento-joven",
    title: "School Wars: impacto real en talento joven",
    excerpt: "Cómo School Wars conecta educación, competencia y oportunidades para la nueva generación gamer.",
    cover: "/distrito1.jpg",
    category: "Comunidad & Talento",
    author: "PR Esports League",
    date: "2026-02-19",
    content: [
      "School Wars ha demostrado que el gaming competitivo puede ser una herramienta real de desarrollo para jóvenes.",
      "Más allá del torneo, promovemos disciplina, trabajo en equipo y exposición a carreras dentro del ecosistema digital.",
      "El próximo paso es escalar este modelo en más instituciones y regiones de Puerto Rico.",
    ],
  },
];

export function mapDbPostToUi(post) {
  return {
    slug: post.slug,
    title: post.title,
    excerpt: post.excerpt || "",
    cover: post.cover_image_url || "/logo.png",
    category: post.category || "Noticias",
    author: post.author_name || "PR Esports League",
    date: post.published_at || post.created_at,
    contentMd: post.content_md || "",
    content: (post.content_md || "").split(/\n\n+/).filter(Boolean),
  };
}
